import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'

const alarmModule = {
  state: {
    eventLogList: [],
  },
  actions: {
    // 取得EventLog列表
    async getEventLogList({ commit, rootState }, searchParams) {
      const currentCommunityId = rootState.commonModule.currentCommunityId
      return await baseFetch(
        API.getEventLogList.url,
        API.getEventLogList.method,
        {
          ...searchParams,
          communityId: currentCommunityId
        }
      )
    },

    // 註冊告警視窗設備到WebSocket
    async addWebSocketSubscript(_, postBody) {
      return await baseFetch(
        API.addWebSocketSubscript.url,
        API.addWebSocketSubscript.method,
        postBody
      )
    },
  },
  mutations: {
  },
  getters: {
  },
  namespaced: true
}

export default alarmModule